module.exports = __webpack_public_path__ + "img/ezSortLogo.372f9e24.png";